<template>
  <div>
    <h2>Hackathon</h2>
    <div class="box-content">
       <ul class="hackathon-list">
         <li v-for="item in hackathon">
           <p class="hackathon-date">{{ item.date }}</p>
           <p class="competition">{{ item.competition }}</p>
           <p class="award">{{ item.award }}</p>
         </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters('About',{
        'hackathon': 'getHackathon'
      })
    }
  }
</script>
<style scoped>
  table{
    text-align: left;
    margin: 0 auto;
  }
  td{
    padding-right: 20px;
  }
  .award{
    color: #c93a40;
  }
  ul{
    list-style: none;
  }
  .hackathon-list > li{
    margin-bottom: 30px;
  }
  .hackathon-list > li > p{
    margin: 0;
  }
  .competition{
    font-weight: bold;
  }
  .hackathon-list{
    padding-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/HackathonList.vue